/**
 * SettingsPage — Configuración de Studio Media Labs.
 *
 * Estructura de pestañas lista para crecer. En esta etapa sólo vive
 * «Redes sociales»: conexión, canales e historial de publicaciones.
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ArrowLeft, Share2, ShieldCheck } from 'lucide-react';
import { SocialConnectionPanel, SocialPostHistory } from '../components/social';
import ClaudeAccessPanel from '../components/claude/ClaudeAccessPanel';

const TABS = [
  { id: 'social', label: 'Redes sociales', icon: Share2 },
  { id: 'claude', label: 'Claude', icon: ShieldCheck },   // Envío MC-2
  // Próximas pestañas se agregan acá sin tocar el layout.
];

const initialTab = () => {
  const requested = new URLSearchParams(window.location.search).get('tab');
  return TABS.some((t) => t.id === requested) ? requested : TABS[0].id;
};

export default function SettingsPage() {
  const [tab, setTab] = useState(initialTab);

  return (
    <div className="settings-page" data-testid="settings-page">
      <header className="settings-head">
        <Link to="/studio" className="settings-back" data-testid="settings-back">
          <ArrowLeft size={15} /> Volver al Studio
        </Link>
        <h1>Configuración</h1>
      </header>

      <div className="settings-body">
        <nav className="settings-tabs" data-testid="settings-tabs">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              className={`settings-tab ${tab === id ? 'active' : ''}`}
              onClick={() => setTab(id)}
              data-testid={`settings-tab-${id}`}
            >
              <Icon size={15} /> {label}
            </button>
          ))}
        </nav>

        <main className="settings-content">
          {tab === 'social' && (
            <>
              <div className="settings-section-head">
                <h2>Redes sociales</h2>
                <p>
                  Publicá o programá las imágenes y videos que generás en Studio
                  Media Labs directamente en tus redes.
                </p>
              </div>
              <SocialConnectionPanel />
              <div className="settings-divider" />
              <SocialPostHistory />
            </>
          )}
          {tab === 'claude' && (
            <>
              <div className="settings-section-head">
                <h2>Claude</h2>
                <p>
                  Qué proyectos hechos en la app puede modificar Claude cuando está
                  conectado a tu cuenta, hasta cuándo, y cómo volver atrás.
                </p>
              </div>
              <ClaudeAccessPanel />
            </>
          )}
        </main>
      </div>

      <Toaster
        position="bottom-right"
        theme="dark"
        richColors
        toastOptions={{
          style: {
            background: '#1a1a2e',
            border: '1px solid rgba(16, 185, 129, 0.3)',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}
